export default "__VITE_ASSET__BB217gwj__"